import {
    /** FETCH APPLICATION  */
    FETCH_NOTIFYPAYMENT_FULFILLED,
    FETCH_NOTIFYPAYMENT_REJECTED,
    FETCH_NOTIFYPAYMENT_PENDING,
    RESET_NOTIFYPAYMENT
} from "../../actions/v3/notifyPayment";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_NOTIFYPAYMENT_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_NOTIFYPAYMENT_FULFILLED:
            return {
                ...state,
                notifyPayment: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_NOTIFYPAYMENT_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_NOTIFYPAYMENT:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};